<template>
  <div style="min-height: 750px;" class="blue-grey lighten-5 sec-5">
    <v-row
      justify="center"
      align-content="center"
      class="mx-1 fill-height"
      :class="[$vuetify.breakpoint.mdAndUp?'pdx-10':'mx-5']"
    >
      <v-col cols="12" class="text-center mb-5">
        <BaseDisplayTitle
          content="Key Assignment"
          size="2"
          class="mb-5 blue-grey--text font-weight-black text--lighten-2"
          data-aos="fade-up"
        ></BaseDisplayTitle>

        <h4
          class="blue-grey--text text--lighten-2 font-weight-regular"
          data-aos="fade-up"
        >
          Congrats on your purchase!
        </h4>
        <h4
          class="font-weight-regular"
          data-aos="fade-up"
        >
          Be advised that you need to assign your keys to activate your account.
        </h4>
      </v-col>

      <v-col
        cols="12"
        :class="$vuetify.breakpoint.mdAndUp?'d-flex justify-center':''"
        data-aos="fade-up"
      >
        <KeyAssignmentForm></KeyAssignmentForm>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'ResellerKeyAssignment',

    components: {
      KeyAssignmentForm: () => import('@/components/reseller/KeyAssignmentForm.vue'),
    }
  }
</script>

<style lang="scss" scoped>

</style>